import { Loading } from 'element-ui';
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
const nextunit={B:"KB",KB:"MB",MB:"GB",GB:"TB"}
export default {
	Loading(text="......  ......"){
		this.loadingInstance=Loading.service({
			lock: true,
			text,
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		})
	},
	loadingInstance:null,
	Loadingclose(){
		if(this.loadingInstance){
			this.loadingInstance.close()
		}
		this.loadingInstance=null
	},
	myfloat(title,message,confirm=function(){},cancel="取消",arr,myclass=""){//arr:input设置初始值: [{id:"inputid",val:"初始值"}]
		let obj={
			title,
			message,
			dangerouslyUseHTMLString:true,
			showCancelButton:true,
			closeOnClickModal:false,
			closeOnHashChange:false,
			beforeClose:function(typ,box,close){
				if(typ!=="confirm"){
					if(typeof cancel ==="function"){
						cancel(close)
						return
					}
					Message({message:cancel})
					close()
					return
				}
				confirm(close)
			},
			callback:function(){
				const box = document.querySelector(".el-message-box__wrapper")
				box.parentNode.removeChild(box)
			}
		}
		if(myclass!==""){
			obj.customClass=myclass
		}
		MessageBox(obj)
		if(arr){
			const timer = setInterval(()=>{
				let newarr = arr
				arr=[]
				if(newarr.length===0){
					clearInterval(timer)
					return
				}
				newarr.forEach(e=>{
					const dom = document.getElementById(e.id)
					if(dom){
						dom.value=""
						dom.innerHTML=""
						if(e.val){
							dom.value=e.val
						}
						if(e.html){
							dom.innerHTML=e.html
						}
					}else{
						arr.push(e)
					}
				})
			},50)
		}
	},
	messageErr(message,duration=2000){//success/warning/info/error
		Message({message,type:"error",duration})
	},
	messageErrClose(message){
		message+="（请联系系统管理员，钉钉搜索“汪权”）"
		Message({message,type:"error",duration:0,showClose:true})
	},
	messageSuc(message,duration=2000){
		Message({message,type:"success",duration})
	},
	messageInf(message,duration=2000){
		Message({message,type:"info",duration})
	},
	stristext(v){
		var reg = RegExp(/'|"|<|>/);
		if(v===""||v===null){
			return {istrue:false,msg:"不能为空"}
		}
		if(reg.exec(v)){
			return {istrue:false,msg:"不能包含特殊符号"}
		}
		return {istrue:true}
	},
	nameistrue(v){
		if(v===''){
			return {istrue:false,msg:"请输入用户名"}
		}
		if(!/^[\d]+$/.test(v)||v.length!=11){
			return {istrue:false,msg:"请输入11位电话号码"}
		}
		return {istrue:true}
	},
	pwdistrue(v){
		if(v===''){
			return {istrue:false,msg:"请输入密码"}
		}
		return {istrue:true}
	},
	codeistrue(v,code){
		if(v===''){
			return {istrue:false,msg:"请输入验证码"}
		}
		if(v!==code){
			return {istrue:false,msg:"验证码错误"}
		}
		return {istrue:true}
	},
	random(m,n){
		let a=Math.min(m,n),b=Math.max(m,n)
		return Math.floor(a+Math.random()*(b-a))
	},
	objIsSame(obj1,obj2){
		if(obj1.length !== obj2.length){
			return false
		}
		const arr = Object.keys(obj1);
		for(let i=0;i<arr.length;i++){
			if(obj1[arr[i]] !== obj2[arr[i]]){
				return false
			} 
		}
		return true
	},
	date2str(t){
		if(!t)return ""
		if(typeof t==="string"){
			return t
		}
		let year=t.getFullYear()
		let mouth=t.getMonth()+1
		if(mouth<10){
			mouth="0"+mouth
		}
		let day=t.getDate()
		if(day<10){
			day="0"+day
		}
		return year+"-"+mouth+"-"+day
	},
	date2int(t){
		if(!t)return -1
		let str=this.date2str(t)
		let arr=str.split("-")
		return (+arr[0])*100+(+arr[1])
	},
	timelong(s,e){
		if(e==="永久"){
			return "------"
		}
		let st = s.split("-")
		let et = e.split("-")
		let year = (+et[0])-(+st[0])
		let mouth = (+et[1])-(+st[1])
		let day = (+et[2])-(+st[2])
		if (day >30){
			mouth+=1
		}else if (day<0){
			mouth-=1
		}
		if(mouth>12){
			year+=1
			mouth-=12
		}else if(mouth<0){
			year-=1
			mouth+=12
		}
		let res=""
		if(year!==0){
			res+=year+"年"
		}
		if(mouth!==0){
			res += mouth +"月"	
		}
		if(res===""){
			res="不足一月"
		}
		return res
	},
	floatTo3p(a){
		return Math.round(a*1000)/1000
	},
	floatTo2p(a){
		return Math.round(a*100)/100
	},
	floatTo1p(a){
		return Math.round(a*10)/10
	},
	division(a,b){
		if(b===0){
			return 0
		}
		return a/b
	},
	sizeshow(size,unit="B"){
		if(size<1){
			return this.floatTo3p(size)+unit
		}
		if(size>=1&&size<10){
			return this.floatTo2p(size)+unit
		}
		if(size>=10&&size<100){
			return this.floatTo1p(size)+unit
		}
		if(size>=100&&size<=1024){
			return Math.round(size)+unit
		}
		return this.sizeshow(size/1024,nextunit[unit])
	}
}